export const isUrlRelative = (urlToTest: string) =>
  new URL(document.baseURI).origin ===
  new URL(urlToTest, document.baseURI).origin;
